/**
 * @author Aston Kingsley
 */
import { clearNotifications } from "../statemanagement/notificationSlice";
import notificationWorker from "./workerInstance";
import { fetchNotificationsCount } from "../statemanagement/asyncThunkAPI";

let isWorkerListening = false;
let workerEventListener = null;

/**
 * below function we will listen the message from the web worker
 * if notification success message that is send from worker listen here
 * @param {*} dispatch 
 * @param {*} apiUrl 
 */
export const startNotificationWorker = (dispatch) => {
  if (!isWorkerListening) {
    // Remove any existing event listener first
    if (workerEventListener) {
      notificationWorker.removeEventListener("message", workerEventListener);
    }
    
    workerEventListener = (event) => {
      const { type } = event.data;
      if (type === "TICK") {
        dispatch(fetchNotificationsCount());
      }
    };

    notificationWorker.addEventListener("message", workerEventListener);
    isWorkerListening = true;
  }

  notificationWorker.postMessage("START");
};



/**
 * below function we will stop the worker instance
 * @param {*} dispatch 
 */
export const stopNotificationWorker = (dispatch) => {
  notificationWorker.postMessage("STOP");
  
  // Clean up event listener
  if (workerEventListener) {
    notificationWorker.removeEventListener("message", workerEventListener);
    workerEventListener = null;
  }
  
  isWorkerListening = false;
  dispatch(clearNotifications());
};
